/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Art10Inputs */

const en__field_enum_subject_art10 = /** @type {(inputs: _Field_Enum_Subject_Art10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

const de__field_enum_subject_art10 = /** @type {(inputs: _Field_Enum_Subject_Art10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunst`)
};

/**
* | output |
* | --- |
* | "Art" |
*
* @param {_Field_Enum_Subject_Art10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_art10 = /** @type {((inputs?: _Field_Enum_Subject_Art10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Art10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_art10(inputs)
	return de__field_enum_subject_art10(inputs)
});
export { _field_enum_subject_art10 as "_field_enum_SUBJECT_ART" }